export enum BikeSelectEvent {
    SELECT_SEARCH_SUGGEST_BIKE = 'adp:bike:search:suggest:select',
    SELECT_MY_BIKE = 'adp:my-bike:select',
}
